import { render, staticRenderFns } from "./CountedServiceTransactionStatistics.vue?vue&type=template&id=bd983e42&"
import script from "./CountedServiceTransactionStatistics.vue?vue&type=script&lang=js&"
export * from "./CountedServiceTransactionStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports